import { cn } from '../cn';

export interface SwitchProps {
  checked: boolean;
  onChange?: (v: boolean) => void;
  disabled?: boolean;
  label?: string;
  className?: string;
}

/** 34 × 20, radius 10, 2 px padding, 16 px white knob; accent when on, track2 when off. */
export function Switch({ checked, onChange, disabled, label, className }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className={cn(
        'flex h-5 w-[34px] flex-none items-center rounded-[10px] border-0 p-[2px] transition-colors disabled:opacity-40',
        checked ? 'justify-end bg-accent' : 'justify-start bg-track2',
        className,
      )}
    >
      <span className="block h-4 w-4 rounded-lg bg-white" />
    </button>
  );
}

/** Row: title + mono hint on the left, switch on the right (desktop 10px rows, mobile 48px rows). */
export function SwitchRow({
  title,
  hint,
  checked,
  onChange,
  disabled,
  trailing,
  className,
  first,
}: SwitchProps & { title: string; hint?: string; trailing?: React.ReactNode; first?: boolean }) {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 border-t border-line py-2.5 md:min-h-0',
        'min-h-12 px-4 md:px-0',
        first && 'border-t-0 md:border-t',
        className,
      )}
    >
      <div className="flex min-w-0 flex-col gap-[3px]">
        <span className={cn('text-lg font-normal text-fg md:text-base md:font-medium', disabled && 'text-fg3')}>{title}</span>
        {hint && <span className="font-mono text-sm leading-[1.4] text-fg4 md:text-xs">{hint}</span>}
      </div>
      {trailing ?? <Switch checked={checked} onChange={onChange} disabled={disabled} label={title} />}
    </div>
  );
}
